import { useMemo } from "react";
import BidimencionalChart from "../../../../../Components/apexcharts/BidimencionalChart";
import { IChatComStatus } from "../../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";

interface IClientesHaMaisTempoNaFilaChartProps {
    listaChatsAbertosFirebase: Array<IChatComStatus> | undefined;
}

export default function ClientesHaMaisTempoNaFilaChart(
    props: IClientesHaMaisTempoNaFilaChartProps
) {
    const { listaChatsAbertosFirebase } = props;

    const dadosDoGrafico = useDadosGrafico(listaChatsAbertosFirebase);
    const titleComplement = dadosDoGrafico
        ? `(em ${dadosDoGrafico.exibicao})`
        : "";

    return (
        <BidimencionalChart
            options={{
                title: {
                    text: `Clientes aguardando há mais tempo na fila ${titleComplement}`,
                },
                xaxis: {
                    categories: dadosDoGrafico?.clientes ?? [],
                },
                noData: {
                    text: dadosDoGrafico?.clientes
                        ? "Nenhum registro"
                        : "Carregando",
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                    },
                },
            }}
            type="bar"
            series={[
                {
                    name: `tempo em ${dadosDoGrafico?.exibicao}`,
                    data: dadosDoGrafico?.horas.map((h) => Math.round(h)) ?? [], // esse map é para que o número esteja fixo em 2 casas decimais
                },
            ]}
        />
    );
}

function useDadosGrafico(
    listaChatsAbertosFirebase: Array<IChatComStatus> | undefined
) {
    return useMemo(() => {
        if (listaChatsAbertosFirebase) {
            console.log(listaChatsAbertosFirebase);
            console.log(
                listaChatsAbertosFirebase.filter(
                    (num) =>
                        num.NumeroCliente === null ||
                        num.NumeroCliente === undefined
                )
            );
            // é preciso usar o Array.from para clonar o array porque o sort modifica diretamente o array
            const listaTop10AtendimentosMaisAntigosDaFila =
                listaChatsAbertosFirebase
                    .filter((a) => {
                        return a.IdUsuario === 0;
                    })
                    .sort(
                        (a, b) =>
                            (a.conversa?.[0]?.TimeStamp ?? 0) -
                            (b.conversa?.[0]?.TimeStamp ?? 0) // comparando o timestamp da primeira mensagem
                    )
                    .slice(0, 10);

            const timestampDiffs = listaTop10AtendimentosMaisAntigosDaFila.map(
                (a) => Date.now() - (a.conversa?.[0]?.TimeStamp ?? Date.now())
            );
            const exibicao = timestampDiffs.every((a) => a / 1000 / 60 / 60 < 7)
                ? "minutos" // se só tiver diffs com menos de 7 horas, a exibição é por minutos
                : timestampDiffs.every((a) => a / 1000 / 60 / 60 / 24 < 7)
                ? "horas"
                : "dias"; // se só tiver diffs com menos de 7 dias, a exibição é por horas

            return {
                horas: timestampDiffs.map(
                    (a) =>
                        a /
                        1000 /
                        60 /
                        (exibicao !== "minutos" ? 60 : 1) /
                        (exibicao === "dias" ? 24 : 1)
                ), // tempo do início em horas ou minutos
                clientes: listaTop10AtendimentosMaisAntigosDaFila.map(
                    (a) =>
                        a.NomeCliente ||
                        a.ProfileName ||
                        a.NumeroCliente?.replace("whatsapp:", "")
                ),
                exibicao,
            };
        }

        return undefined;
    }, [listaChatsAbertosFirebase]);
}
